import { Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'

import { TranslatePipe } from '@ngx-translate/core'
import { MatDialogModule } from '@angular/material/dialog'

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
  standalone: true,
  imports: [TranslatePipe, MatDialogModule]
})
export class AlertDialogComponent implements OnInit {
  title = ''
  message = ''
  subMessage = ''
  image = ''
  obj: any
  constructor(
    public dialog: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.title = this.data.title || 'Alert'
    this.message = this.data.message
    this.subMessage = this.data.subMessage
    this.image = this.data.image || 'alert-icon.png'
  }

  confirm() {
    this.dialog.close()
  }
}
